import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ContactAndAddressService } from '@services/contact-and-address/contact-and-address.service';
import { TranslateService } from '@services/translate/translate.service';
import { Models } from '@ibexfusion/models';
import { MessengerService } from '@services/messenger/messenger.service';
import { TimePickerComponent } from '../../../../../../components/time-picker/time-picker.component';

@Component({
    selector: 'edit-code-snippet-dialog',
    templateUrl: './edit-code-snippet-dialog.component.html',
    styleUrls: ['./edit-code-snippet-dialog.component.scss'],
    providers: [],
    standalone: false
})
export class EditCodeSnippetDialogComponent implements OnInit {
  element: any;
  titleError = false;
  snippetError = false;

  constructor(public dialogRef: MatDialogRef<EditCodeSnippetDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private dialog: MatDialog) {
  }

  async ngOnInit() {
    this.element = this.data.data[this.data.index] || { title: '', snippet: '' };
  }

  async save() {
    debugger;
    this.titleError = this.element.title?.length < 2;
    this.snippetError = this.element.snippet.length < 10;
    if (this.titleError || this.snippetError) {
      return;
    }
    this.dialogRef.close(this.element);
  }
}
